const LabelStyleBreeds = {
  backgroundColor: 'rgba(255, 134, 142, 0.6)',
  borderRadius: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  paddingBottom: '10px',
};

export { LabelStyleBreeds };
